import type { PrefetchContext, PrefetchedDataProps } from '#src/shared/prefetch';

import { useCountryCode, useLocale } from '#src/app/shared/hooks/l10n';
import type { MergedState } from '#src/app/shared/hooks/state';
import { useMergedStates } from '#src/app/shared/hooks/state';

import { prefetchStarterDashboardV2PageDataFromApi, useStarterDashboardV2PageDataFromApi } from './pageData';

export type StarterDashboardV2PagePrefetchedContext = Readonly<{
	pageData: Parameters<typeof useStarterDashboardV2PageDataFromApi>[0];
}>;

export type StarterDashboardV2PageCombinedState = MergedState<ReturnType<typeof useStarterDashboardV2PageDataFromApi>>;

export function usePageContext(
	slug: string,
	prefetchedData?: StarterDashboardV2PagePrefetchedContext,
): StarterDashboardV2PageCombinedState {
	const locale = useLocale();
	const countryCode = useCountryCode();
	return useMergedStates(useStarterDashboardV2PageDataFromApi(prefetchedData?.pageData, { slug, countryCode, locale }));
}

export async function prefetchPageContext(context: PrefetchContext): Promise<StarterDashboardV2PagePrefetchedContext> {
	const [pageData] = await Promise.all([
		prefetchStarterDashboardV2PageDataFromApi(context, {
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			slug: context.params.slug!,
			countryCode: context.l10n.countryCode,
			locale: context.l10n.locale,
		}),
	]);

	return { pageData };
}

export type StarterDashboardV2PagePrefetchedDataProps = PrefetchedDataProps<StarterDashboardV2PagePrefetchedContext>;
